// extracted by mini-css-extract-plugin
export default {"data-hook-wrapper":"_2vKEO","dataHookWrapper":"_2vKEO","core-badge":"_1zwLs","coreBadge":"_1zwLs"};